import React from 'react';
import { Link } from "react-router";
import Nav from '../components/Nav';
import '../css/SSS.css';

class SSS extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {return (
    <div className="sss">
        <Nav/>
        <div className="main">
          <div className="hero">
            <p className="asdf">Nasıl Yardımcı Olabiliriz?</p>
          </div>

          <div className="articles-main">
            <h4 style={{color: "#000", display: "none"}}>Buralarda yeni misin? <Link to="/sss/start" style={{color: "#F57029"}}>Başlangıç Rehberi</Link>'mize göz atabilirsin.</h4>

            <Link to="/sss/yazilar"><div className="article">
              <h2>Yazılar</h2>
              <div>Yazılar neydi? Yeniyor mu bari?</div>
            </div></Link>

            <Link to="/sss/yorumlar"><div className="article">
              <h2>Yorumlar</h2>
              <div>Yazıların yorumları! Evet. Yorum.</div>
            </div></Link>

            <Link to="/sss/bildirimler"><div className="article">
              <h2>Bildirimler</h2>
              <div>Sürekli dıt dıt yapan bazen can sıkıcı olabilen şeyler.</div>
            </div></Link>

            <Link to="/sss/profil"><div className="article">
              <h2>Profil</h2>
              <div>Senin profilin. Senin ayarların.</div>
            </div></Link>
          </div>
        </div>
    </div>
)}};

class StartPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {return (
    <div className="sss">
        <Nav/>
        <div className="main">
          <div className="hero">
            <p className="asdf">Başlarken</p>
          </div>

          <div className="articles">
            <h4 style={{color: "#000"}}>Öncelikle seni burada görmek güzel! Bu makale şunları içeriyor:</h4>
            
            <ul>
              <li></li>
            </ul>


            <h2 id="sss-yazilar">Yazılar</h2>

            <h3>Genel Bakış</h3>
            <p>"Yazı"lar, yazarların gönlünce yazdığı ve başkalarının okuyabildiği uzun veya kısa metinlerdir.
            Yazılar her konuda olabilir, bir görüşten bir hikayeye kadar.
            Yazarlardan başka kimse yazı paylaşamaz ama giriş yapmış kullanıcılar varolan yazıları beğenebilir ve
            yorum yapabilir.</p>

            <h3>Nasıl Bir Yazı Oluştururum?</h3>
            <p>Eğer bir Yazar değilseniz yazmanız malesef mümkün değil :( <br/> Yazarsanız, Taslaklar sayfasına gidin,
            bir taslak oluşturun ve "Yayınla" seçeneğine tıklayın. İşte yazınız yayında!</p>

            <h3>Ana Sayfa'daki Yazılar Neye Göre Sıralanır?</h3>
            <p>Ana Sayfa'daki tüm yazılar tarihe göre yeniden eskiye doğru sıralanır. Kısacası son paylaşılan yazı
            sol üstte olacaktır.</p>

            <h3>Belirli Bir Yazara Ait Tüm Yazıları Nasıl Tek Bir Yerde Görebilirim?</h3>
            <p>Yazarın profil resmine veya kullanıcı adına tıklayın, profilinde tüm yazılarını bulabilirsiniz.</p>

            <h3>Yazımı Düzenleyebilir Miyim?</h3>
            <p>Malesef şuanda yazı düzenlemeye izin verilmiyor.</p>

            
            <h2 id="sss-yorumlar">Yazı Yorumları</h2>

            <h3>Genel Bakış</h3>
            <p>Yazı Yorumları, yazı hakkında bir fikir belirtme, eleştirme, veya sadece "güzel yazı." yazmak içindir.</p>

            <h3>Yanıtlar Nedir?</h3>
            <p>Yanıtlar, bir yoruma cevap vermek istediğinizde tek tek alt alta yorum yapmak yerine bir yorumun altına 
            yanıt vermenizi sağlar.</p>

            <h3>Nasıl Bir Yoruma Yanıt Veririm?</h3>
            <p>Yanıtlamak istediğiniz yoruma gidin ve yorumun altındaki "Yanıtla" seçeneğine tıklayın. Ardından yanıtınızı yazın
            ve "Yayınla" seçeneğine tıklayarak yayınlayın. İşte bu kadar!</p>


            <h2 id="sss-bildirimler">Bildirimler</h2>

            <h3>Neler İçin Bildirim Alabilirim?</h3>
            <p>Bir yazınız beğenildiğinde ve yorumunuza yanıt verildiğinde bildirim alırsınız.</p>

            <h3>Bildirimler Sayfasındaki Mavi Noktalar Neyi İfade Ediyor?</h3>
            <p>"Okundu" olarak işaretlenmemiş bildirimlerin sol tarafında mavi bir nokta olur, böylece hangisinin
            okunmuş olarak işaretlenip işaretlenmediğini kolayca anlayabilirsiniz.</p>

            <h3>Bildirimleri Seçerek Okundu Olarak İşaretlemenin Yolu Var Mı?</h3>
            <p>Malesef şimdilik sadece tüm bildirimleri okuyabilirsiniz. "Tümünü Okundu Olarak İşaretle" butonuna tıklayarak
            tüm bildirimleri okundu olarak işaretleyebilirsiniz.</p>

            <h3>Bildirimleri Silmenin Yolu Var Mı?</h3>
            <p>Şuan bildirimler silinemiyor.</p>


            <h2 id="sss-profil">Profil</h2>

            <h3>Nasıl Profilimi Düzenlerim?</h3>
            <p>Sağ üstteki profilinizin üstüne gidin, "Profil" seçeneğine tıklayın. İşte profiliniz! Sağ alttaki "Profili Düzenle"
            seçeneğine tıklayarak profilinizi düzenleyebilirsiniz!</p>

            <h3>Başka Bir Kullanıcı Hangi Bilgilerimi Görebilir?</h3>
            <p>Profilinizi ziyaret eden bir kişi, kullanıcı adınızı, profil fotoğrafınızı ve biyografinizi görebilir.
            E-Posta ve şifrenizi sadece siz görebilirsiniz.</p>

            <h3>Profil Bilgilerim Nerelerde Gözükebilir?</h3>
            <p>Yorumlarınızda, yanıtlarınızda ve başkalarına giden bildirimlerinizde. Eğer <a>Yazar iseniz</a> yazınızda da görünebilir.</p>
          </div>
        </div>
    </div>
)}};

class Yazılar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {return (
    <div className="sss">
        <Nav/>
        <div className="main">
          <div className="hero">
            <p className="asdf">Yazılar</p>
          </div>

          <div className="articles">
            <div className="makale-icerik">
              <h4 style={{color: "#000"}}>Makale İçeriği</h4>
              <ul>
                <a href="#1"><li>Genel Bakış</li></a>
                <a href="#2"><li>Nasıl Bir Yazı Oluştururum?</li></a>
                <a href="#3"><li>Ana Sayfa'daki Yazılar Neye Göre Sıralanır?</li></a>
                <a href="#4"><li>Belirli Bir Yazara Ait Tüm Yazıları Nasıl Tek Bir Yerde Görebilirim?</li></a>
                <a href="#5"><li>Yazımı Düzenleyebilir Miyim?</li></a>
              </ul>
            </div>

           <div className="anlatim">
            <h3 id="1">Genel Bakış</h3>
            <p>"Yazı"lar, yazarların gönlünce yazdığı ve başkalarının okuyabildiği uzun veya kısa metinlerdir.
            Yazılar her konuda olabilir, bir görüşten bir hikayeye kadar.
            Yazarlardan başka kimse yazı paylaşamaz ama giriş yapmış kullanıcılar varolan yazıları beğenebilir ve
            yorum yapabilir.</p>

            <h3 id="2">Nasıl Bir Yazı Oluştururum?</h3>
            <p>Eğer bir Yazar değilseniz yazmanız malesef mümkün değil :( <br/> Yazar iseniz, Taslaklar sayfasına gidin,
            bir taslak oluşturun, bir yazı girin ve "Yayınla" seçeneğine tıklayın. İşte yazınız yayında!</p>

            <h3 id="3">Ana Sayfa'daki Yazılar Neye Göre Sıralanır?</h3>
            <p>Ana Sayfa'daki tüm yazılar tarihe göre yeniden eskiye doğru sıralanır. Kısacası son paylaşılan yazı
            en üstte olacaktır.</p>

            <h3 id="4">Bir Yazarın Tüm Yazılarını Nasıl Görebilirim?</h3>
            <p>Yazarın profil resmine veya kullanıcı adına tıklayın, profilinde tüm yazılarını bulabilirsiniz.</p>

            <h3 id="5">Yayındaki Yazımı Düzenleyebilir Miyim?</h3>
            <p>Malesef şuanda yazı düzenlemeye izin verilmiyor.</p>
           </div>
          </div>
        </div>
    </div>
)}};

class Yorumlar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {return (
    <div className="sss">
        <Nav/>
        <div className="main">
          <div className="hero">
            <p className="asdf">Yorumlar</p>
          </div>

          <div className="articles">
            <div className="makale-icerik">
              <h4 style={{color: "#000"}}>Makale İçeriği</h4>
              <ul>
                <a href="#1"><li>Genel Bakış</li></a>
                <a href="#2"><li>Yanıtlar Nedir?</li></a>
                <a href="#3"><li>Nasıl Bir Yoruma Yanıt Veririm?</li></a>
              </ul>
            </div>

           <div className="anlatim">
            <h3 id="1">Genel Bakış</h3>
            <p>Yazı Yorumları, yazı hakkında bir fikir belirtme, eleştirme, veya sadece "güzel yazı." demek içindir.</p>

            <h3 id="2">Yanıtlar Nedir?</h3>
            <p>Yanıtlar, bir yoruma cevap vermek istediğinizde tek tek alt alta yorum yapmak yerine bir yorumun altına 
            yanıt vermenizi sağlar.</p>

            <h3 id="3">Nasıl Bir Yoruma Yanıt Veririm?</h3>
            <p>Yanıtlamak istediğiniz yoruma gidin ve yorumun altındaki "Yanıtla" seçeneğine tıklayın. Ardından yanıtınızı yazın
            ve "Yayınla" seçeneğine tıklayarak yayınlayın. İşte bu kadar!</p>
           </div>
          </div>
        </div>
    </div>
)}};

function Bildirimler2() {return (
    <div className="sss">
        <Nav/>
        <div className="main">
          <div className="hero">
            <p className="asdf">Bildirimler</p>
          </div>

          <div className="articles">
            <div className="makale-icerik">
              <h4 style={{color: "#000"}}>Makale İçeriği</h4>
              <ul>
                <a href="#1"><li>Genel Bakış</li></a>
                <a href="#2"><li>Neler İçin Bildirim Alabilirim?</li></a>
                <a href="#3"><li>Bildirimler Sayfasındaki Mavi Noktalar Neyi İfade Ediyor?</li></a>
                <a href="#4"><li>Bildirimleri Seçerek Okundu Olarak İşaretlemenin Yolu Var Mı?</li></a>
                <a href="#5"><li>Bildirimleri Silmenin Yolu Var Mı?</li></a>
              </ul>
            </div>

           <div className="anlatim">
            <h3 id="1">Genel Bakış</h3>
            <p>Sitedeki hareketleri takip etmenizi ve haberdar olmanızı kolaylaştırır.</p>

            <h3 id="2">Neler İçin Bildirim Alabilirim?</h3>
            <p>Bir yazınız beğenildiğinde ve yorumunuza yanıt verildiğinde bildirim alırsınız.</p>

            <h3 id="3">Bildirimler Sayfasındaki Mavi Noktalar Neyi İfade Ediyor?</h3>
            <p>"Okundu" olarak işaretlenmemiş bildirimlerin sol tarafında mavi bir nokta olur, böylece hangisinin
            okunmuş olarak işaretlenip işaretlenmediğini kolayca anlayabilirsiniz.</p>

            <h3 id="4">Bildirimleri Seçerek Okundu Olarak İşaretlemenin Yolu Var Mı?</h3>
            <p>Malesef şimdilik sadece tüm bildirimleri okuyabilirsiniz. "Tümünü Okundu Olarak İşaretle" butonuna tıklayarak
            tüm bildirimleri okundu olarak işaretleyebilirsiniz.</p>

            <h3 id="5">Bildirimleri Silmenin Yolu Var Mı?</h3>
            <p>Şuan için bildirimler silinemiyor.</p>
           </div>
          </div>
        </div>
    </div>
)};

class Profiller extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {return (
    <div className="sss">
        <Nav/>
        <div className="main">
          <div className="hero">
            <p className="asdf">Profil</p>
          </div>

          <div className="articles">
            <div className="makale-icerik">
              <h4 style={{color: "#000"}}>Makale İçeriği</h4>
              <ul>
                <a href="#1"><li>Genel Bakış</li></a>
                <a href="#2"><li>Başka Bir Kullanıcı Hangi Bilgilerimi Görebilir?</li></a>
                <a href="#3"><li>Profil Bilgilerim Hangi Alanlarda Gözükebilir?</li></a>
              </ul>
            </div>

           <div className="anlatim">
            <h3 id="1">Genel Bakış</h3>
            <p>Kendi konserinde sahnedeymişsin gibi düşünebilirsin, etkileyici şovunu yap!</p>

            <h3 id="3">Başka Bir Kullanıcı Hangi Bilgilerimi Görebilir?</h3>
            <p>Profilinizi ziyaret eden bir kişi, kullanıcı adınızı, profil fotoğrafınızı ve biyografinizi görebilir.
            E-Posta ve şifrenizi sadece siz görebilirsiniz.</p>

            <h3 id="3">Profil Bilgilerim Hangi Alanlarda Gözükebilir?</h3>
            <p>Yorumlarınızda, yanıtlarınızda ve başkalarına giden bildirimlerinizde. Eğer <a>Yazar iseniz</a> yayınlanmış bir yazınızda da görünebilir.</p>
           </div>
          </div>
        </div>
    </div>
)}};

export {SSS, StartPage, Yazılar, Yorumlar, Bildirimler2, Profiller};